import { createAlert } from "actions/alerts";

/**
 * @param {String} id
 * @param {MessageTemplate} newMessageTemplate
 * @returns {Object}
 */
export function updateMessageTemplateAction(id, newMessageTemplate) {
  return {
    type: "UPDATE_MESSAGE_TEMPLATE_ATTRIBUTES",
    id,
    newResourceRecord: newMessageTemplate
  };
}

/**
 * @param {String} id
 * @param {Object} [options]
 * @param {Boolean} [options.shouldShowAlerts]
 * @returns {Function.<Promise>}
 */
export function saveMessageTemplateAction(id, options = {}) {
  return (dispatch, getState) => {
    /** @type MessageTemplate */
    const messageTemplateRecord = getState().resources.messageTemplate.getIn(["byId", id]);

    return new Promise((resolve, reject) => dispatch({
      CALL_API: {
        method: "patch",
        endpoint: `/message_templates/${id}`,
        payload: messageTemplateRecord.serialize(),
        types: [
          "SAVE_ONE_MESSAGE_TEMPLATE_REQUEST",
          "SAVE_ONE_MESSAGE_TEMPLATE_SUCCESS",
          "SAVE_ONE_MESSAGE_TEMPLATE_FAILURE"
        ],
        dispatchCallbacks: [
          {
            request() {
              if (options.shouldShowAlerts) {
                dispatch(createAlert({
                  message: "Satisfaction survey settings have been updated.",
                  alertType: "success"
                }));
              }

              resolve();
            },
            fireOnStatus: "success"
          },
          {
            request() {
              if (options.shouldShowAlerts) {
                dispatch(createAlert({
                  message: "Something went wrong",
                  alertType: "error"
                }));
              }

              reject();
            },
            fireOnStatus: "error"
          }
        ]
      }
    }));
  };
}
